import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'property-item-header',
  standalone: false,
  templateUrl: './property-item-header.component.html',
  styleUrl: './property-item-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PropertyItemHeaderComponent {

}
